export default "__VITE_ASSET__BVqH5VrC__"